// ชื่อทีมที่แสดงบนหน้าจอ.
// รหัสทีมในไฟล์ Excel ยังเป็น "FS" ตามเดิม (คอลัมน์ FS Pick / FS-Win, ชีท
// FS_Ban_Pick ฯลฯ) — ห้ามเปลี่ยนตรงนั้น ไม่งั้นตัวอ่านชีตจะหาแถวของเราไม่เจอ
export const TEAM_SHORT = "TO BE";

export const BRAND_COLORS = {
  bg: "#fff6f7",
  surface: "#ffffff",
  text: "#111827",
  textMuted: "#6b7280",
  primary: "#ff1026",
  primaryLight: "#ff4d5f",
  primaryDark: "#a30013",
  success: "#00d084",
  danger: "#ff4d6d",
  warn: "#ffd166",
  chartTick: "#374151",
  chartGrid: "rgba(255,16,38,0.12)",
  primaryGlow: "rgba(255,16,38,0.35)",
  border: "rgba(255,16,38,0.30)",
  borderSoft: "rgba(255,16,38,0.16)",
  logoBg: "rgba(17,24,39,0.88)",
};

export const BUTTON_VARIANTS = {
  primary: {
    background: "linear-gradient(135deg, #ff1026 0%, #a30013 100%)",
    color: "#ffffff",
    boxShadow: "0 8px 30px rgba(255,16,38,0.35)",
  },
  primarySoft: {
    background: "linear-gradient(135deg, #ff4d5f 0%, #b0001a 100%)",
    color: "#ffffff",
    boxShadow: "0 8px 30px rgba(255,16,38,0.30)",
  },
  ghost: {
    background: "rgba(255,16,38,0.08)",
    color: "#b91c1c",
    boxShadow: "none",
  },
};
